import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ModalData } from '@app/modules/registration/registration-card/models/modal.model';
import { ScrollService } from './scroll.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalDataSubject = new BehaviorSubject<ModalData | null>(null);
  modalData$: Observable<ModalData | null> = this.modalDataSubject.asObservable();

  private modalResultSubject = new Subject<boolean>();
  private isModalOpen = false;
  private renderer: Renderer2;

  constructor(
    public rendererFactory: RendererFactory2,
    private scrollService: ScrollService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  openModal(data: ModalData) {
    if (!this.isModalOpen) {
      this.isModalOpen = true;
      this.modalDataSubject.next(data);
      this.scrollService.disableScroll();
    }
  }

  closeModal() {
    if (this.isModalOpen) {
      this.isModalOpen = false;
      this.modalDataSubject.next(null);
      this.scrollService.enableScroll();
    }
  }

  confirmModal(): Observable<boolean> {
    return this.modalResultSubject.asObservable();
  }

  setModalResult(result: boolean) {
    this.modalResultSubject.next(result);
  }
}
